import React from 'react';

const NotFound = () => {
    return (
        <div>
            <h1>Sorry Not Found</h1>
        </div>
    );
};

export default NotFound;